.group {
  margin: 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(3.5rem, 1fr));
  gap: var(--space-3);
}

.cluster {
  display: flex;
  align-items: flex-start;
  gap: var(--space-8);
  flex-wrap: wrap;
}

.readout {
  display: grid;
  grid-template-areas:
    'value'
    'label';
  gap: var(--space-1);
  min-width: 0;
}

.valueLine {
  grid-area: value;
  display: flex;
  align-items: baseline;
  gap: var(--space-1);
  margin: 0;
}

.value {
  color: var(--ink-primary);
  font-family: var(--font-display);
  font-size: var(--text-xl);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  line-height: 1;
}

.valueLarge {
  font-size: var(--text-readout);
}

.valueQuiet {
  color: var(--ink-muted);
}

.unit,
.label {
  color: var(--ink-muted);
  font-family: var(--font-display);
  font-size: var(--text-2xs);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
}

.label {
  grid-area: label;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  width: fit-content;
  color: var(--status-ink, var(--ink-secondary));
  font-family: var(--font-display);
  font-size: var(--text-xs);
  letter-spacing: var(--tracking-wide);
}

.statusDot {
  width: var(--space-2);
  height: var(--space-2);
  border: 1px solid currentcolor;
  border-radius: var(--radius-pill);
  background: var(--status-dot, var(--ink-muted));
  box-shadow: 0 0 0 var(--space-1) var(--status-wash, transparent);
}

.statusNeutral {
  --status-dot: var(--ink-muted);
}

.statusLive {
  --status-dot: var(--positive);
  --status-ink: var(--positive);
  --status-wash: var(--positive-wash);
}

.statusPlanned {
  --status-dot: var(--info);
  --status-ink: var(--info);
}

.statusWarning {
  --status-dot: var(--warning);
  --status-ink: var(--warning);
  --status-wash: var(--warning-wash);
}

.statusDanger {
  --status-dot: var(--negative);
  --status-ink: var(--negative);
  --status-wash: var(--negative-wash);
}
